export default "__VITE_PUBLIC_ASSET__16313510__"